export default {"src":"/_next/static/media/left.e421d055.svg","height":296,"width":123,"blurWidth":0,"blurHeight":0};